/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProfileValue model module.
 * @module model/ProfileValue
 * @version 1.0.0
 */
class ProfileValue {
    /**
     * Constructs a new <code>ProfileValue</code>.
     * @alias module:model/ProfileValue
     */
    constructor() { 
        
        ProfileValue.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProfileValue</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProfileValue} obj Optional instance to populate.
     * @return {module:model/ProfileValue} The populated <code>ProfileValue</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProfileValue();

            if (data.hasOwnProperty('profile_value')) {
                obj['profile_value'] = ApiClient.convertToType(data['profile_value'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} profile_value
 */
ProfileValue.prototype['profile_value'] = undefined;






export default ProfileValue;

